import { createFileRoute } from '@tanstack/react-router';

import { InvoicesListPage } from '@/features/invoices/InvoicesListPage';

export const Route = createFileRoute('/admin/_app/invoices')({
  component: InvoicesListPage,
});
